/* ============================================================
   Vaveāo — shared scroll-reveal observer
   Reveals any element with class `.va-reveal` once it scrolls
   into view. Re-runs on Shopify section load so it works live
   in the theme editor.
   ============================================================ */
(function () {
  var supports = 'IntersectionObserver' in window;
  var observer = supports
    ? new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('va-in');
            observer.unobserve(entry.target);
          }
        });
      }, { threshold: 0.15 })
    : null;

  function reveal(root) {
    var scope = root || document;
    var els = scope.querySelectorAll('.va-reveal:not(.va-in)');
    if (!supports) {
      els.forEach(function (el) { el.classList.add('va-in'); });
      return;
    }
    els.forEach(function (el) { observer.observe(el); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { reveal(); });
  } else {
    reveal();
  }

  // Theme editor: re-scan a section when it (re)loads.
  document.addEventListener('shopify:section:load', function (event) {
    reveal(event.target);
  });
})();
